export class Staging {
  oncological: Oncological[] = [];
  hematological: Hematological[] = [];
  lymphoma: Lymphoma[] = [];
  stagingType: 'oncological' | 'hematological' | 'lymphoma' | 'noOncological' | '' | 'oncologico' | 'error' = 'oncological';
  currentStagingCode: string;

  constructor() {
    this.oncological = [];
    this.hematological = [];
    this.lymphoma = [];
    this.stagingType = '';
    this.currentStagingCode = '';
  }
}

export class Oncological {
  id: string;
  stagingCode: string;
  stagingDate: Date | null;
  tumor: StagingDetails;
  nodules: StagingDetails;
  metastasis: StagingDetails;
  grade!: StagingDetails;
  psa!: StagingDetails;
  gleason!: StagingDetails;
  riskFactor!: StagingDetails;
  peripheralBloodInvolvement!: StagingDetails;
  s!: StagingDetails;
  mitoticRate!: StagingDetails;
  pathologicalStaging!: PathologicalStaging;
  morphology!: Morphology | null;
  createdAt: Date | null = null;


  constructor() {
    this.id = '';
    this.stagingCode = '';
    this.stagingDate = null;
    this.createdAt = null;
    this.tumor = new StagingDetails();
    this.nodules = new StagingDetails();
    this.metastasis = new StagingDetails();
  }

  setOncologicalStaging(oncological: any, pathologicalStaging: any, morphology: any, staging: string, diagnosticDate: Date) {
    this.id = oncological.id ?? '';
    this.stagingDate = diagnosticDate;
    this.createdAt = new Date();
    this.stagingCode = staging;
    this.tumor = oncological.t !== null ? oncological.t : new StagingDetails();
    this.nodules = oncological.n !== null ? oncological.n : new StagingDetails();
    if (oncological.m !== null) {
      this.metastasis.code = oncological.m.code ?? '';
      this.metastasis.id = oncological.m.id ?? '';
      this.metastasis.version = oncological.m.version ?? '';
      this.metastasis.language = oncological.m.language ?? '';
      this.metastasis.estadiamento = oncological.m.estadiamento ?? '';
      this.metastasis.description = oncological.m.description ?? '';
    }
    else {
      this.metastasis = new StagingDetails();
    }

    this.grade = oncological.grade !== null ? oncological.grade : new StagingDetails();
    this.psa = oncological.psa !== null ? oncological.psa : new StagingDetails();
    this.gleason = oncological.gleason !== null ? oncological.gleason : new StagingDetails();
    this.s = oncological.s !== null ? oncological.s : new StagingDetails();
    this.mitoticRate = oncological.mitoticrate !== null ? oncological.mitoticrate : new StagingDetails();
    this.riskFactor = oncological.riskFactor !== null ? oncological.riskFactor : new StagingDetails();
    this.peripheralBloodInvolvement = oncological.peripheralBloodInvolvement !== null ? oncological.peripheralBloodInvolvement : new StagingDetails();

    this.pathologicalStaging = new PathologicalStaging();
    this.morphology = new Morphology();

    if (pathologicalStaging) {
      this.pathologicalStaging.group = pathologicalStaging.group ?? '';
      this.pathologicalStaging.pt = pathologicalStaging.pt ?? '';
      this.pathologicalStaging.pm = pathologicalStaging.pm ?? '';
      this.pathologicalStaging.pn = pathologicalStaging.pn ?? '';
    }
    if (morphology) {
      this.morphology = morphology;
    }

    return this;
  }
}

export class StagingDetails {
  id: string;
  description: string;
  code: string;
  version: string;
  language: string;
  grupoEstadiamentoId: string;
  estadiamento: string;

  constructor() {
    this.id = '';
    this.description = '';
    this.code = '';
    this.version = '';
    this.language = '';
    this.grupoEstadiamentoId = '';
    this.estadiamento = '';
  }
}

export class Metastasis extends StagingDetails {
  grupoGradeId: string;
  grupoMitoticRateId: string;
  grupoRiskFactorId: string;
  grupoPSAId: string;
  grupoGleasonId: string;
  grupoSId: string;
  grupoPeripheralBloodInvolvementId: string;

  constructor() {
    super();
    this.grupoGradeId = '';
    this.grupoMitoticRateId = '';
    this.grupoRiskFactorId = '';
    this.grupoPSAId = '';
    this.grupoGleasonId = '';
    this.grupoSId = '';
    this.grupoPeripheralBloodInvolvementId = '';
  }
}

export class Morphology {
  id: string;
  description: string;
  version: string;
  language: string;

  constructor() {
    this.id = '';
    this.description = '';
    this.version = '';
    this.language = '';
  }
}

export class Hematological {

  id: string;
  classification: StagingDetails;
  subClassification: StagingDetails;
  stagingCode: string;
  stagingDate: Date | null;
  createdAt: Date | null = null;

  constructor() {
    this.id = '';
    this.classification = new StagingDetails();
    this.subClassification = new StagingDetails();
    this.stagingCode = '';
    this.createdAt = null;
    this.stagingDate = null;
  }
}

export class Lymphoma {
  id: string;
  createdAt: Date | null;
  stagingDate: Date | null
  stagingCode: string;
  involvement: Involvement;
  sympthons: LymphomaAJCCItem;
  spleen: LymphomaAJCCItem;
  bulkyMass: LymphomaAJCCItem;
  extranodal: LymphomaAJCCItem | null;
  
  constructor() {
    this.id = '';
    this.stagingDate = null;
    this.createdAt = null; this.stagingCode = '';
    this.involvement = new Involvement();
    this.sympthons = new LymphomaAJCCItem();
    this.spleen = new LymphomaAJCCItem();
    this.bulkyMass = new LymphomaAJCCItem();
    this.extranodal = new LymphomaAJCCItem();
  }

  setLymphoma(stagingDate: Date | null, involvement: Involvement, sympthons: LymphomaAJCCItem, spleen: LymphomaAJCCItem, bulkyMass: LymphomaAJCCItem, stagingCode: string, extranodal?: LymphomaAJCCItem) {
    this.id = '';
    this.stagingDate = stagingDate;
    this.createdAt = new Date();
    this.stagingCode = '';
    this.involvement = involvement;
    this.sympthons = sympthons;
    this.spleen = spleen;
    this.bulkyMass = bulkyMass;
    this.extranodal = extranodal ?? null;
    this.stagingCode = stagingCode;
    return this;
  }
}

export class Involvement {

  line: string;
  type: string;
  description: string;

  constructor() {
    this.line = '';
    this.type = '';
    this.description = '';
  }
}

export class LymphomaAJCCItem {

  line: string;
  value: string;
  description: string;

  constructor() {
    this.line = '';
    this.value = '';
    this.description = '';
  }
}

export class PathologicalStaging {
  group: string;
  pt: string;
  pn: string;
  pm: string;

  constructor() {
    this.group = '';
    this.pt = '';
    this.pn = '';
    this.pm = '';
  }
}